import Dashboard from '@pages/Dashboard';
import ProductList from '@pages/products/ProductList';
import ProductForm from '@pages/products/ProductForm';
import ProductDetail from '@pages/products/ProductDetail';
import WarehouseSettings from '@pages/WarehouseSettings';

/**
 * The route table. Every entry declares the (module, action) it needs, and the
 * MODULE REGISTRY decides whether it exists at all — so adding or removing a
 * module in modules.config.js still drives nav, routes and guards together.
 *
 * `nav: true` also puts the route in the sidebar / bottom bar.
 */
const PAGES = [
  { path: '/', element: <Dashboard />, label: 'Dashboard', module: 'core', action: 'view', nav: true, icon: 'layout-dashboard' },

  { path: '/products', element: <ProductList />, label: 'Products', module: 'inventory', action: 'view', nav: true, icon: 'package' },
  { path: '/products/new', element: <ProductForm />, module: 'inventory', action: 'create' },
  { path: '/products/:id/edit', element: <ProductForm />, module: 'inventory', action: 'update' },
  { path: '/products/:id', element: <ProductDetail />, module: 'inventory', action: 'view' },

  { path: '/warehouse', element: <WarehouseSettings />, label: 'Warehouse', module: 'warehouse', action: 'view', nav: true, icon: 'warehouse' },
];

/** Every routable page whose module is present in the live registry. */
export function buildRoutes(modules = {}) {
  return PAGES.filter((p) => !!modules[p.module]);
}

/** The subset that belongs in the navigation. */
export function buildNav(modules = {}) {
  return buildRoutes(modules).filter((p) => p.nav);
}
